import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../permit-for-oversize-vehicles.routes';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { PermitForOversizeVehicleTravelDataForm } from './forms/permit-for-oversize-vehicle-travel-data.form';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { updateVehicles } from '../../../../../../store/actions/application.actions';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { VehicleFormComponent } from './components/vehicle-form/vehicle-form.component';

@Component({
  selector: 'app-permit-for-oversize-vehicle-travel-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    DatePickerComponent,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    VehicleFormComponent
  ],
  providers: [
    PermitForOversizeVehicleTravelDataForm
  ],
  templateUrl: './permit-for-oversize-vehicle-travel-data-section.component.html'
})
export class PermitForOversizeVehicleTravelDataSectionComponent implements OnInit, OnDestroy {
  public stages = stages;

  public store$: Store = inject(Store);

  public router: Router = inject(Router);

  public route: ActivatedRoute = inject(ActivatedRoute);

  public form: PermitForOversizeVehicleTravelDataForm = inject(PermitForOversizeVehicleTravelDataForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateVehicles({
        currentApp: this.application() || {},
        payload: this.form.toWriteModel(),
        vehicles: this.form.vehicleValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../podmiot-zlecajacy'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
